export enum AdpVoucherHolderStatus {    
    Available = 0,
    PendingRedemption = 1,
    Redeemed = 2,
    PendingRetired = 3,
    Retired = 4
}